var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutomateGreenIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 8.5C6.88071 8.5 8 7.38071 8 6C8 4.61929 6.88071 3.5 5.5 3.5C4.11929 3.5 3 4.61929 3 6C3 7.38071 4.11929 8.5 5.5 8.5ZM5.5 8.5V16.5M5.5 16.5C4.11929 16.5 3 17.6193 3 19C3 20.3807 4.11929 21.5 5.5 21.5C6.88071 21.5 8 20.3807 8 19C8 17.6193 6.88071 16.5 5.5 16.5ZM18.5 16.5V9.2C18.5 8.0799 18.5 7.51984 18.282 7.09202C18.0903 6.71569 17.7843 6.40973 17.408 6.21799C16.9802 6 16.4201 6 15.3 6H12M18.5 16.5C19.8807 16.5 21 17.6193 21 19C21 20.3807 19.8807 21.5 18.5 21.5C17.1193 21.5 16 20.3807 16 19C16 17.6193 17.1193 16.5 18.5 16.5ZM12 6L14.5 8.5M12 6L14.5 3.5",
    stroke: "#10A37F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomateGreenIcon);
export default __webpack_public_path__ + "static/media/AutomateGreenIcon.8c6ee289a5ed822059ec59ecaeddefda.svg";
export { ForwardRef as ReactComponent };